/* eslint-disable no-param-reassign */
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const frenchFormatter = new Intl.NumberFormat('fr-CA', {
  style: 'currency',
  currency: 'CAD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const moneyFormat = (amount: number, lang: string): string => {
  if (lang === 'fr') {
    return `${formatter.format(amount).replace(',', ' ').replace('.', ',').replace('$', '')} $`;
  }
  return formatter.format(amount);
};

export const moneyParse = (price: string, lang: string): number => {
  // FR format
  if (lang === 'fr') return Number(price?.replace(',', '.').replace(/[^0-9.-]+/g, ''));

  // EN format
  return Number(price?.replace(/[^0-9.-]+/g, ''));
};

export const formatPrice = (
  price: number | null | undefined,
  isFrench?: boolean,
  shouldBeNegative?: boolean,
): string => {
  if (!price) return '—';
  const formatted = isFrench ? frenchFormatter.format(price) : formatter.format(price);
  if (price > 0 && shouldBeNegative) {
    return `-${formatted}`;
  }
  return formatted;
};
